import { render } from "./gooey-button.vue?vue&type=template&id=23ab99d8&scoped=true&bindings={\"loading\":\"props\",\"message\":\"props\"}"
import script from "./gooey-button.vue?vue&type=script&lang=js"
export * from "./gooey-button.vue?vue&type=script&lang=js"

import "./gooey-button.vue?vue&type=style&index=0&id=23ab99d8&lang=scss&scoped=true"
import "./gooey-button.vue?vue&type=style&index=1&lang=scss"
script.render = render
script.__scopeId = "data-v-23ab99d8"

export default script